import React from 'react'
import {
  ListProps,
  Pagination,
  Filter,
  TextField,
  TextInput,
  Datagrid,
} from 'react-admin'
import { ResourceName } from '../../../../core/ResourceName'
import List from '../../../common/customized-ra-components/List'
import FilterProps from '../../../common/FilterProps'

const EngineMediaActionFilters = (props: FilterProps) => (
  <Filter {...props}>
    <TextInput source="name" alwaysOn autoFocus />
  </Filter>
)

export const EngineMediaActionList = (props: ListProps) => (
  <List
    {...props}
    exporter={false}
    filters={<EngineMediaActionFilters />}
    perPage={20}
    pagination={<Pagination rowsPerPageOptions={[10, 20, 50, 100, 200]} />}
    bulkActionButtons={false}
  >
    <Datagrid
      size="small"
      rowClick={(id) => `${ResourceName.ENGINE_MEDIA_ACTIONS}/${id}/show`}
    >
      <TextField source="id" label="ID" />
      <TextField source="mediaAction" />
      <TextField source="name" />
    </Datagrid>
  </List>
)
